import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export const emptyCacheStorage = () => {
  const key = localStorage.getItem("RELEASE_NUMBER");
  if (process.env.REACT_APP_RELEASE_NUMBER && key !== process.env.REACT_APP_RELEASE_NUMBER) {
    // clear browser cache and reload page
    localStorage.setItem("RELEASE_NUMBER", process.env.REACT_APP_RELEASE_NUMBER);
    window.location.reload();
  }
};

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "de",
    backend: { queryStringParams: { v: process.env.REACT_APP_RELEASE_NUMBER } },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    useSuspense: true,
  });

export default i18n;
